export default "/_next/static/efad4d347ab1752e45c4065782d21fc7.png";